import styled from 'styled-components';
import { colors } from 'styles/colors';

export const YearSelectionContainer = styled.div`
  width: 114px;
  display: flex;
  gap: 16px;
  align-items: center;

  & > span {
    font-weight: 600;
    font-size: 14px;
    line-height: 180%;
    color: ${colors.text['main-900']};
    font-variant-numeric: tabular-nums;
  }

  & > button {
    padding: 0;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;
